import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

// 1. Daftar doodle yang melayang di background
const doodles = [
  { icon: "📖", top: "15%", left: "5%", delay: 0 },
  { icon: "✈️", top: "40%", left: "10%", delay: 0.5 },
  { icon: "🎬", top: "70%", left: "8%", delay: 1 },
  { icon: "🎵", top: "15%", right: "10%", delay: 0.2 },
  { icon: "⭐", top: "45%", right: "5%", delay: 0.7 },
  { icon: "✨", top: "75%", right: "12%", delay: 1.2 },
  { icon: "🎨", bottom: "5%", left: "45%", delay: 0.4 },
  { icon: "☁️", top: "10%", left: "40%", delay: 0.9 },
];

// 2. Daftar kategori minat yang sudah diperbaiki (Path lengkap)
const categories = [
  { title: "Films", emoji: "🎬", desc: "My cinematic journey", path: "/films" },
  { title: "Books", emoji: "📚", desc: "Stories that shaped me", path: "/books" },
  { title: "Place to Go", emoji: "📍", desc: "Escaping reality", path: "/places" },
  { title: "Music", emoji: "🎧", desc: "Soundtrack of my life", path: "/music" },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="home-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* --- Background Doodles --- */}
      {doodles.map((d, index) => (
        <motion.div
          key={index}
          className="floating-doodle"
          style={{ 
            top: d.top, 
            left: d.left, 
            right: d.right, 
            bottom: d.bottom,
            position: "absolute" 
          }}
          animate={{ y: [0, -20, 0], rotate: [0, 10, -10, 0] }}
          transition={{ 
            duration: 5, 
            repeat: Infinity, 
            delay: d.delay, 
            ease: "easeInOut" 
          }}
        >
          {d.icon}
        </motion.div>
      ))}

      {/* --- Main Content --- */}
      <div className="home-content">
        <motion.h2 
          className="main-title"
          initial={{ y: 20 }}
          animate={{ y: 0 }}
          transition={{ delay: 0.5 }}
          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}
        >
          Welcome to My World 
          <motion.span
            animate={{ rotate: 360 }}
            transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
            style={{ display: "inline-block", cursor: "pointer" }}
            whileHover={{ scale: 1.2 }}
          >
            🌍
          </motion.span>
        </motion.h2>

        <motion.p 
          className="subtitle"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          Hi, I'm Bia — a dreamer who loves films, books, travel, and music.
        </motion.p>

        {/* --- Interest Cards Grid --- */}
        <div className="interest-grid">
          {categories.map((cat, i) => (
            <motion.div 
              key={i}
              className="interest-card"
              whileHover={{ 
                y: -10, 
                scale: 1.05,
                boxShadow: "0 10px 25px rgba(0,0,0,0.1)" 
              }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 + (i * 0.1) }}
              onClick={() => navigate(cat.path)}
            >
              <span className="card-emoji">{cat.emoji}</span>
              <h3>{cat.title}</h3>
              <p>{cat.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Home;